export type NewsArticle = {
  title: string;
  description: string;
  link: string;
  pubDate: string;
  thumbnail?: string | null;
};

export type NewsResponse = {
  articles: NewsArticle[];
  fetchedAt: number;
};

export class NewsService {
  private async post<T>(payload: any): Promise<T> {
    const res = await fetch(process.env.REACT_APP_API_ENDPOINT!, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `Request failed (${res.status})`);
    }

    return (await res.json()) as T;
  }

  async getBBCNews(): Promise<NewsResponse> {
    return this.post<NewsResponse>({
      action: "getBBCNews",
    });
  }
}
